import React from "react";
import { createUseStyles } from "react-jss";
import { onetrust } from "../../analyticsManager";

import styles from "./styles";

const PrivacyPreferences = () => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles();

  return (
    <div>
      <button
        type="button"
        className={classes.privacyPreferences}
        onClick={onetrust.togglePrivacyPreferencesDisplay}
        data-testid="privacy"
      >
        Privacy Preferences
      </button>
    </div>
  );
};

export default PrivacyPreferences;
